<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/bootstrap.png" /></div>
      <p>Bootstrap</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/bootstrap/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "4.1.1",
          linkList: [
            ur + "4.1.1/bootstrap.js",
            ur + "4.1.1/bootstrap.min.js",
            ur + "4.1.1/bootstrap.css",
            ur + "4.1.1/bootstrap.min.css"
          ]
        },
        {
          label: "4.1.0",
          linkList: [
            ur + "4.1.0/bootstrap.js",
            ur + "4.1.0/bootstrap.min.js",
            ur + "4.1.0/bootstrap.css",
            ur + "4.1.0/bootstrap.min.css"
          ]
        },
        {
          label: "4.0.0",
          linkList: [
            ur + "4.0.0/bootstrap.js",
            ur + "4.0.0/bootstrap.min.js",
            ur + "4.0.0/bootstrap.css",
            ur + "4.0.0/bootstrap.min.css"
          ]
        },
        {
          label: "3.3.7",
          linkList: [
            ur + "3.3.7/bootstrap.js",
            ur + "3.3.7/bootstrap.min.js",
            ur + "3.3.7/bootstrap.css",
            ur + "3.3.7/bootstrap.min.css"
          ]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListBootstrap.vue